import { Search as SearchIcon } from '@mui/icons-material'
import {
  Box,
  IconButton,
  InputAdornment,
  type InputProps,
  TextField,
  type TextFieldProps,
} from '@mui/material'
import { useEventListener } from 'usehooks-ts'

interface SearchInputProps {
  value: string
  label?: string
  placeholder?: string
  endAdornment?: InputProps['endAdornment']
  onChange: (value: string) => void
  inputProps?: Omit<TextFieldProps, 'value' | 'onChange'>
}

export default function SearchInput({
  value,
  label,
  inputProps,
  placeholder,
  endAdornment,
  onChange,
}: SearchInputProps) {
  const { t } = useTranslation()
  const [searchText, setSearchText] = useState(value)

  const inputRef = useRef<HTMLInputElement>(null)

  useEventListener('keydown', e => {
    const input = inputRef.current
    if (!input) return

    const isInputFocused = document.activeElement === input

    if (e.key === '/' && !isInputFocused) {
      e.preventDefault()
      input.focus()
    }
  })

  useEffect(() => {
    setSearchText(value)
  }, [value])

  return (
    <Box
      component="form"
      sx={{ width: '100%' }}
      onSubmit={e => {
        e.preventDefault()
        onChange(searchText)
      }}
    >
      <TextField
        fullWidth
        inputRef={inputRef}
        label={label ?? t('views.hub.list.search')}
        placeholder={placeholder}
        value={searchText}
        onChange={e => {
          setSearchText(e.target.value)
        }}
        slotProps={{
          input: {
            endAdornment: endAdornment ?? (
              <InputAdornment position="end">
                <IconButton
                  color="primary"
                  onClick={() => {
                    onChange(searchText)
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        {...inputProps}
      />
    </Box>
  )
}
